import React from 'react';
export function PreHeadline() {
  return <div className="w-full bg-urgency text-white py-3 px-4 text-center" data-id="element-186">
      <p className="font-sans font-medium text-sm md:text-base max-w-3xl mx-auto" data-id="element-187">
        <span className="mr-2" data-id="element-188">⚠️</span>
        ATENCIÓN: Si te despiertas inflamada y agotada todos los días...
      </p>
    </div>;
}